import { render, staticRenderFns } from "./roagna.vue?vue&type=template&id=01c9f426&scoped=true"
import script from "./roagna.vue?vue&type=script&lang=js"
export * from "./roagna.vue?vue&type=script&lang=js"
import style0 from "./roagna.vue?vue&type=style&index=0&id=01c9f426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9f426",
  null
  
)

export default component.exports